export default __webpack_public_path__ + "static/media/dca.e7fa0451.png";